/**
 * Impressum Translations
 * Page-specific translations for Impressum
 */

import enTranslations from './en.json';
import deTranslations from './de.json';
import esTranslations from './es.json';
// Note: de, en, es, and no translations are available for Impressum
// Other languages will fall back to English
import itTranslations from './en.json';
import frTranslations from './en.json';
import ptTranslations from './en.json';
import nlTranslations from './en.json';
import plTranslations from './en.json';
import svTranslations from './en.json';
import noTranslations from './no.json';
import daTranslations from './en.json';
import fiTranslations from './en.json';
import csTranslations from './en.json';
import huTranslations from './en.json';
import roTranslations from './en.json';
import elTranslations from './el.json';
import idTranslations from './en.json';

const translations = {
  en: enTranslations,
  de: deTranslations,
  es: esTranslations,
  it: itTranslations,
  fr: frTranslations,
  pt: ptTranslations,
  nl: nlTranslations,
  pl: plTranslations,
  sv: svTranslations,
  no: noTranslations,
  da: daTranslations,
  fi: fiTranslations,
  cs: csTranslations,
  hu: huTranslations,
  ro: roTranslations,
  el: elTranslations,
  id: idTranslations
};
export default translations;
